// extracted by mini-css-extract-plugin
module.exports = {"time_decimal":"funcs_time_decimal__N-Egi","red":"funcs_red__1BZSx","green":"funcs_green__1WrUx","wrap":"funcs_wrap__3zFJA","flag":"funcs_flag__3hlOt"};